module.exports = __webpack_public_path__ + "static/media/customer-diagram.95b2e459.svg";